module.exports = __webpack_public_path__ + "img/realNameImg_c.99a4ae82.png";